import { RadioGroupField } from 'components/form'
import { IvcfPerguntaEnum } from 'graphql/types.generated'
import { MetaRoot } from 'util/metaPath'

import { IVCF_PERGUNTAS, IvcfAplicacaoModel } from '../../model-ivcf'
import { IvcfPerguntaWrapper } from '../components/IvcfPerguntaWrapper'

interface IvcfPerguntaFieldProps {
  ivcfPath: MetaRoot<IvcfAplicacaoModel>
  pergunta: IvcfPerguntaEnum
  isEditing: boolean
  hideBorderBottom?: boolean
  readOnly?: boolean
}

export function IvcfPerguntaField(props: IvcfPerguntaFieldProps) {
  const { ivcfPath, pergunta, hideBorderBottom, readOnly, isEditing } = props

  const name = ivcfPath[pergunta]
  const { options } = IVCF_PERGUNTAS[pergunta]

  return (
    <IvcfPerguntaWrapper pergunta={pergunta} hideBorderBottom={hideBorderBottom} isEditing={isEditing}>
      <RadioGroupField
        name={name}
        options={Object.entries(options).map(([value, label]) => ({
          value,
          label,
        }))}
        showErrorField={false}
        disabled={readOnly}
      />
    </IvcfPerguntaWrapper>
  )
}
